module.exports = __webpack_public_path__ + "static/FiraCode-Regular-bfec314a4943882a8e81f066004b74f3.woff2";